import {
  Container,
  Title,
  Text,
  Card,
  SimpleGrid,
  Stack,
  ThemeIcon,
  Badge,
  Group,
} from '@mantine/core';
import { Users, BarChart2, Calendar } from 'react-feather';
import { useAuthStore } from '../../stores/auth';

export function PartnerDashboard() {
  const { user } = useAuthStore();
  const firstName = user?.first_name || 'there';

  return (
    <Container size="xl" py="xl">
      <Group justify="space-between" mb="xl">
        <div>
          <Title order={1}>Partner Dashboard</Title>
          <Text size="lg" c="dimmed" mt="xs">
            Welcome back, {firstName}. Here's your partner overview.
          </Text>
        </div>
        <Badge size="lg" variant="light" color="violet">
          Partner View
        </Badge>
      </Group>

      <SimpleGrid cols={{ base: 1, sm: 3 }} spacing="lg" mb="xl">
        <Card withBorder padding="xl">
          <Stack align="center" gap="md">
            <ThemeIcon size={56} radius="xl" variant="light" color="violet">
              <Users size={28} />
            </ThemeIcon>
            <Title order={4} ta="center">
              Cohorts
            </Title>
            <Text size="sm" c="dimmed" ta="center">
              Overview of cohorts with your organization.
            </Text>
          </Stack>
        </Card>

        <Card withBorder padding="xl">
          <Stack align="center" gap="md">
            <ThemeIcon size={56} radius="xl" variant="light" color="blue">
              <BarChart2 size={28} />
            </ThemeIcon>
            <Title order={4} ta="center">
              Reports
            </Title>
            <Text size="sm" c="dimmed" ta="center">
              Program analytics and progress reports.
            </Text>
          </Stack>
        </Card>

        <Card withBorder padding="xl">
          <Stack align="center" gap="md">
            <ThemeIcon size={56} radius="xl" variant="light" color="green">
              <Calendar size={28} />
            </ThemeIcon>
            <Title order={4} ta="center">
              Key Dates
            </Title>
            <Text size="sm" c="dimmed" ta="center">
              Important milestones and deadlines.
            </Text>
          </Stack>
        </Card>
      </SimpleGrid>

      <Card withBorder padding="xl">
        <Title order={3} mb="md">
          Partner Features
        </Title>
        <Text c="dimmed">
          This dashboard is a placeholder for the Partner persona. Features include:
        </Text>
        <ul style={{ marginTop: '1rem', color: 'var(--mantine-color-dimmed)' }}>
          <li>View cohort overview and status</li>
          <li>Access program reports and analytics</li>
          <li>Track key dates and milestones</li>
          <li>Monitor participant engagement</li>
        </ul>
      </Card>
    </Container>
  );
}

export default PartnerDashboard;
